<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewReaction" class="btn btn-primary">
              Create Reaction
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
            
          <base-alert 
            :type="message.type" 
            :dismissible="true" 
            @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
          <template slot="is_giid_only_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> False </label>
            <label v-if="props.cell_value == 1"> True </label>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.reaction }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} User Task Reaction Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label required">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select item"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Reaction"
              required
              input-classes="form-control"
              v-model="UserTaskReactionModel.reaction"
            />
          </div>
          <div class="col-lg-12">
            <div class="form-group has-label">
              <base-input type="file" id="file-input" required label="Upload Reaction" accept="image/*" @change="onFileChange($event)" />
              <div id="preview-container">
                <div class="preview" v-if="uploadModel.image_url">
                  <img :src="uploadModel.image_url" class="img img-thumbnail" />
                </div>
                <div class="preview" v-else>
                  <img :src="UserTaskReactionModel.image_url" class="img img-thumbnail" />
                </div>
              </div>
            </div>
          </div>                 
        </div>
        <div class="row">
          <div class="col-md-6"></div>
        </div>
        <br>
        
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          v-on:click="createUpdateReaction"
          class="btn btn-primary"
          v-bind:disabled="disableButtonSubmit"
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import api_loyalty from "../api/api";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";
import "vue2-datepicker/index.css";

export default {
  name: "ReactionList",
  data() {
    return {
      is_allowed_create: false,
      is_loads3presigned: false,
      watch_brand_code: "PHFortune",
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      isEdit : false,
      titlePopup: "Create",
      message: null,
      UserTaskReactionModel: {
        id:null,
        brand_code: "PHFortune",
        reaction: "",
        image_url: ""
      },
      uploadModel: {
        imageFile: null,
        image_url: null,
        imagePresignedUrl: '',
      },
      showModalCreate: false,
      allReaction:null,
      rows: [],
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Reaction",
          name: "reaction",
          sort: true,
        },                 
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    this.isBrandCodeDisabled = false;
    this.isPromoTypeDisabled = false;
    this.onRefreshData();
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('usertaskreactionconfig')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('usertaskreactionconfig')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe) {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.watch_brand_code = this.UserTaskReactionModel.brand_code = "PHChe";
        this.is_allowed_create = true;
      }

      if (isAdministrator || isFortune) {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.watch_brand_code = this.UserTaskReactionModel.brand_code = "PHFortune";
        this.is_allowed_create = true;
      }
    },
    resetMessage() {
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm() {
      this.UserTaskReactionModel = {
        id: null,
        brand_code: this.watch_brand_code,
        reaction: "",
        image_url: ""
      };

      this.uploadModel = {
        imageFile: null,
        image_url: null,
        imagePresignedUrl: '',
      }
    },
    onCreateNewReaction() {
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.isBrandCodeDisabled = false;
      this.isEdit = false;
      this.onResetForm();
    },
    toggleActive() {},
    async onRefreshData() {
      api_loyalty
        .GetAllUserTaskReaction(this.watch_brand_code)
        .then((data) =>
        {
          try
          {
            if(data.isSuccess){
              this.rows = data.data;
              this.allReaction = data.data;
            }
          } catch (e)
          {
            console.log(e);
          }
        });
      this.UserTaskReactionModel.reaction = "";
      this.UserTaskReactionModel.image_url = "";
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.onResetForm();
      this.UserTaskReactionModel = this.allReaction.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.showModalCreate = true;
      this.isBrandCodeDisabled = true;
      this.isPromoTypeDisabled = true;
      this.titlePopup = "Update";
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
        };
        this.UserTaskReactionModel.id = deleteRequest.id;
        
        api_loyalty
          .DeleteUserTaskReaction(this.UserTaskReactionModel.brand_code, this.UserTaskReactionModel)
          .then((response) => {
            this.onRefreshData();
            let msg = {
              message:
                "Failed to delete user task reaction '" +
                element.reaction +
                "'.",
              type: "danger",
            };

            if(response.isSuccess){
              msg = {
                message:
                  "Success delete user task reaction '" + element.reaction + "'.",
                type: "success",
              };
            }

            this.deleteMessages.push(msg);
          })
          .catch((e) => {
            console.log(e);
            let msg = {
              message:
                "Failed to delete user task reaction '" +
                element.reaction +
                "'.",
              type: "danger",
            };
            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    
    async createUpdateReaction() {
      if (this.UserTaskReactionModel.id) 
       {
        this.UserTaskReactionModel.modify_date = new Date().toISOString();
        this.UserTaskReactionModel.brand_code = this.watch_brand_code;
        api_loyalty
        .UpdateUserTaskReaction(this.UserTaskReactionModel.brand_code, this.UserTaskReactionModel)
        .then((response) => {
          this.onRefreshData();
          var popupType = "success"
          if(response.isSuccess == false){
            popupType = "danger";
          }

          this.message = {
            message: response.message,
            type: popupType,
          };
        })
        .catch((e) => {
          console.log(e);
          this.message = {
            message: "Failed to Insert User Task Reaction.",
            type: "danger",
          };
        });
       }
       else
       {
          this.UserTaskReactionModel.brand_code = this.watch_brand_code;
          this.UserTaskReactionModel.create_date = new Date().toISOString();
          this.UserTaskReactionModel.modify_date = new Date().toISOString();

          api_loyalty
          .AddUserTaskReaction(this.UserTaskReactionModel.brand_code, this.UserTaskReactionModel)
          .then((response) => {
            this.onRefreshData();
            var popupType = "success"
            if(response.isSuccess == false){
              popupType = "danger";
            }

            this.message = {
              message: response.message,
              type: popupType,
            };
          })
          .catch((e) => {
            console.log(e);
            this.message = {
              message: "Failed to Insert User Task Reaction",
              type: "danger",
            };
          });
        }

        if (this.uploadModel.imagePresignedUrl) {
          api_loyalty.S3PutObject(
            this.uploadModel.imagePresignedUrl,
            this.uploadModel.imageFile
          );
        }

       this.onResetForm();
       this.showModalCreate = false;
    },
    onFileChange(event) {
      const file = event.target.files[0]; 

      if (file) {
        this.uploadModel.imageFile = file;
        const reader = new FileReader(); 

        reader.onload = (e) => {
          this.uploadModel.image_url = e.target.result;

          api_loyalty
          .GenerateS3PresignedUploadUrl(
            "usertask-catalog-image", file, "reaction", this.watch_brand_code
          )
          .then((data) => {
            try {
              if(data.isSuccess)
              {
                this.uploadModel.imagePresignedUrl = data.data.s3Object.uploadUrl;
                this.UserTaskReactionModel.image_url = data.data.s3Object.cdnUrl;
              }
            } catch (e) {
              console.log(e);
            }
          });
        };

        reader.readAsDataURL(file); 
      }
    },  
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
  },
  watch: {
    watch_brand_code: function() {
      this.UserTaskReactionModel.brand_code = this.watch_brand_code;
      this.onRefreshData();
    },
  },
  computed: {
    disableButtonSubmit: function () {
      let isDisabled = true;

      if(this.UserTaskReactionModel.brand_code && this.UserTaskReactionModel.reaction &&
      this.UserTaskReactionModel.image_url) {
        isDisabled = false;
      }
      
      return isDisabled;
    },
  }
};
</script>
<style scoped>
  .img-thumbnail {
    width: 25%;
  }

  .required::after {
    content: " *";
    color: red;
    font-weight: bold;
  }
</style>

